"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _draftJs = require("draft-js"),
    _lodash = _interopRequireDefault(require("lodash.isequal")),
    _MentionTag = _interopRequireDefault(require("../../../RichTextEditor/components/MentionTag"));

require("./_content-view.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function getContentState(content, truncate) {
  return truncate && 3 < content.blocks.length ? (content.blocks.filter(function (block, index) {
    return 3 > index;
  }).map(function (block, index) {
    return 2 === index ? _objectSpread({}, block, {
      text: "".concat(block.text, "...")
    }) : block;
  }), (0, _draftJs.convertFromRaw)(content)) : (0, _draftJs.convertFromRaw)(content);
}

function getEntityStrategy(mutability) {
  return function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
      var entityKey = character.getEntity();
      return null !== entityKey && contentState.getEntity(entityKey).getMutability() === mutability;
    }, callback);
  };
}

function getDecorator() {
  return new _draftJs.CompositeDecorator([{
    strategy: getEntityStrategy("SEGMENTED"),
    component: _MentionTag["default"]
  }]);
}

var ContentView = function (_Component) {
  function ContentView(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ContentView), _this = _super.call(this, props), _initialiseProps.call((0, _assertThisInitialized2["default"])(_this));
    var content = props.content,
        truncate = props.truncate,
        contentState = getContentState(content, truncate),
        decorator = getDecorator();
    return _this.state = {
      editorState: _draftJs.EditorState.createWithContent(contentState, decorator)
    }, _this;
  }

  (0, _inherits2["default"])(ContentView, _Component);

  var _super = _createSuper(ContentView);

  return (0, _createClass2["default"])(ContentView, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var content = this.props.content;
      (0, _lodash["default"])(prevProps.content, content) || this.setEditor();
    }
  }, {
    key: "render",
    value: function render() {
      var editorState = this.state.editorState;
      return _react["default"].createElement("div", {
        className: "content-view"
      }, _react["default"].createElement(_draftJs.Editor, {
        readOnly: !0,
        editorState: editorState
      }));
    }
  }]), ContentView;
}(_react.Component),
    _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setEditor = function () {
    var _this2$props = _this2.props,
        content = _this2$props.content,
        truncate = _this2$props.truncate,
        contentState = getContentState(content, truncate),
        decorator = getDecorator();

    _this2.setState({
      editorState: _draftJs.EditorState.createWithContent(contentState, decorator)
    });
  };
},
    _default = ContentView;

exports["default"] = _default;